import { Table, Input, Modal,Avatar } from 'antd';
import React, { Component } from 'react';
import { sagaModal } from 'redux-saga-modal'
import 'antd/dist/antd.css';
import dayjs from 'dayjs'
import styles from './history.modules.scss'
import * as apis from '@/apis'
import * as selectors from '@/models/notifies/selectors'
import { times } from 'lodash';
const { Search } = Input;

class SendHistoryDialog extends Component {
    state = {
        data:[],
        total:0,
        offset:0,
        loading:false
    };
    queryHistory = async (offset) => {
        const { notify = {}} = this.props
        const params={limit:10,offset}
        const result = await apis.searchSendNotifyHistory(notify._id,params)
        this.setState({data:result.data,total:result.total})
    };
    deleteNotify = async(event) => {
        event.preventDefault()
        await apis.deleteNotify(event.target.id);
        this.queryHistory(this.state.offset)
    };
    componentDidMount(){
        this.queryHistory(0)
    };
    getColumns() {
        return [
          {
            key: '_id',
            title: '',
            width: 30,
            render: (text, record, idx) => <div style={{whiteSpace: 'nowrap'}}>{idx+1}.</div>
          },
          {
            title: '标题',
            width: 200,
            render: item => (
              <div>{item.notify.title}</div>
            )
          },
          {
            title: '内容',
            render: item => (
              <div>
                <div>{item.notify.content}</div>
              </div>
            )
          },
          {
            title: '店铺',
            render: item => (
              <div>
                <div>{item.tenant?.name}</div>
              </div>
            )
          },
          {
            title: '接受人',
            render: item => (
              <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar shape="circle" src={item.receiver?.avatar} />
            <span style={{ paddingLeft: 5 }}>{item.receiver?.name}</span>
          </div>
            )
          },
          {
            title: '状态',
            render: item => (
              <div>
                <div>{item.isRead?'已读':'未读'}</div>
              </div>
            )
          },
          {
            title: '阅读时间',
            width: 180,
            render: item => (
              <div>
                {item.readAt ? dayjs(item.readAt).format('YYYY-MM-DD  HH:mm:ss') : '-'}
              </div>
            )
          },
          {
            title: '发送时间',
            width: 180,
            render: item => (
              <div>
                {item.createdAt ? dayjs(item.createdAt).format('YYYY-MM-DD  HH:mm:ss') : '-'}
              </div>
            )
          },
          {
            title: '操作',
            width: 80,
            render: item => {
              return (
                <div>
                  <a id={item._id} onClick={this.deleteNotify}>删除</a>
                </div>
              )
            }
          }
        ]
    }
     handleTableChange = async(pagination, filters, sorter) => {
      const offset = (pagination.current - 1) * pagination.pageSize
      this.setState({offset:offset})
      this.queryHistory(offset)
    };
    render() {
      const pagination = {
        showQuickJumper: true,
        total: this.state.total,
        pageSize: +10,
        current: Math.floor(this.state.offset / +10) + 1
      }
      
        return (
          <div>
              <Table
                className={styles.table}
                columns={this.getColumns()}
                rowKey="_id"
                dataSource={this.state.data}
                pagination={pagination}
                onChange={this.handleTableChange}
                loading={this.state.loading}></Table>
          </div>)
    }
}

const SendHistoryInfoDialog = ({
    modal,
    isOpen,
    show,
    update,
    destroy,
    click,
    submit,
    hide,
    showModal,
    updateModal,
    submitModal,
    clickModal,
    hideModal,
    destroyModal,
    ...ownProps
  }) => (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={1200}
      style={{ top: 30 }}
      visible={isOpen}
      
      onCancel={hide}>
      <SendHistoryDialog onSuccess={hide} {...ownProps} />
    </Modal>
  )
  
  export default sagaModal({
    name: 'SEND_NOTIFY_HISTORY_DIALOG',
  })(SendHistoryInfoDialog)